<template>
  <v-container fluid class="mt-10 d-flex justify-center">
    <v-card
      max-width="650"
      class="pa-6 rounded-xl elevation-3"
      outlined
    >
      <!-- HEADER -->
      <div class="text-center mb-6">
        <v-icon large color="primary">mdi-card-account-details-outline</v-icon>
        <div class="text-h5 font-weight-bold mt-2">Estatus de Membresía</div>
        <v-divider class="mt-4"></v-divider>
      </div>

      <!-------------------------
          LOADING
      -------------------------->
      <div v-if="loading" class="text-center my-8">
        <v-progress-circular
          indeterminate
          color="primary"
          size="50"
          width="4"
        />
        <div class="subtitle-1 mt-3">Buscando información...</div>
      </div>

      <!-------------------------
          ERROR GENERAL
      -------------------------->
      <v-alert
        v-else-if="error"
        type="error"
        outlined
        class="mb-6"
        border="left"
        elevation="1"
      >
        <v-icon small class="mr-2">mdi-alert-circle</v-icon>
        {{ error }}
      </v-alert>

      <!-------------------------
          INFORMACIÓN
      -------------------------->
      <div v-else-if="Data">

        <!-- CARD STATUS -->
        <v-alert
          :type="Data.Estatus === 'ACTIVO' ? 'success' : 'warning'"
          outlined
          border="left"
          prominent
          class="mb-6"
        >
          <div class="d-flex align-center">
            <v-icon
              :color="Data.Estatus === 'ACTIVO' ? 'success' : 'warning'"
              class="mr-2"
            >
            </v-icon>

            <div class="text-h6 font-weight-bold">
              {{ Data.Estatus === 'ACTIVO' ? 'Membresía Activa' : 'Membresía Suspendida' }}
            </div>
          </div>

          <div class="mt-2" v-if="Data.Estatus !== 'ACTIVO'">
            Comunícate con tu agente para evitar perder beneficios.
          </div>
        </v-alert>

        <!-- DATOS PRINCIPALES -->
        <v-card class="pa-4 elevation-1 rounded-lg mb-6">
          <div class="text-subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <v-icon color="primary" small class="mr-2">mdi-information-outline</v-icon>
            Información de la Membresía
          </div>

          <v-row dense>
            <v-col cols="12" sm="6" class="py-2 d-flex align-center">
              <v-icon small class="mr-2">mdi-card-account-details</v-icon>
              Membresía:
              <strong class="ml-1">{{ Data.IdTarjeta }}</strong>
            </v-col>

            <v-col cols="12" sm="6" class="py-2 d-flex align-center">
              <v-icon small class="mr-2">mdi-file-check</v-icon>
              Plan:
              <strong class="ml-1">{{ Data.Plan }}</strong>
            </v-col>

            <v-col cols="12" sm="6" class="py-2 d-flex align-center">
              <v-icon small class="mr-2">mdi-shield-check-outline</v-icon>
              Coberturas:
              <strong class="ml-1">{{ Data.Coberturas }}</strong>
            </v-col>

            <v-col cols="12" sm="6" class="py-2 d-flex align-center">
              <v-icon small class="mr-2">mdi-currency-usd</v-icon>
              Tipo Pago:
              <strong class="ml-1">{{ Data.TipoPago }}</strong>
            </v-col>

            <v-col cols="12" sm="6" class="py-2 d-flex align-center">
              <v-icon small class="mr-2">mdi-calendar-check</v-icon>
              Inicio Vigencia:
              <strong class="ml-1">{{ formatFecha(Data.FecIniVig) }}</strong>
            </v-col>
          </v-row>
        </v-card>

        <!-- ERROR EXTRA -->
        <v-alert
          v-if="errorresponse"
          type="error"
          outlined
          border="left"
          elevation="1"
          class="mt-4"
        >
          <v-icon small class="mr-2">mdi-alert-circle</v-icon>
          {{ errorresponse }}
        </v-alert>
      </div>

      <!-------------------------
          SIN RESULTADOS
      -------------------------->
      <v-alert
        v-else
        type="error"
        outlined
        border="left"
        prominent
        class="my-4"
      >
        <v-icon small class="mr-2">mdi-magnify-close</v-icon>
        <strong>No se encontraron registros con la información proporcionada.</strong>
      </v-alert>
    </v-card>
  </v-container>
</template>


<script>
import formatFecha from '@/mixins/formatFecha'

export default {
  name: "ConsultaFolio",
  mixins: [formatFecha],
  props: {
    guid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      Data: null,
      errorresponse: null
    }
  },
  mounted() {
    if (this.guid) {
      this.getCita()
    }
  },
  methods: {
    getCita() {
      this.loading = true
      this.error = null
      this.Data = null
      this.$http.get(`consulta/qr?guid=${ this.guid }`)
        .then(response => {
          if (response.status === 200 && response.data) {
            this.Data = response.data[0]
            console.log(this.Data)
          }
        })
        .catch(err => {
          this.error = "Error al consultar el folio."
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
